<template>
  <div class="core-summary-item" :class="additionalClass" :id="id">
    <span class="title">{{ title }}</span>
    <span class="value" v-if="value" v-html="value"></span>
  </div>
  <p v-if="remark" class="mb-4 text-sm whitespace-pre-line font-thin text-neutral-550">{{ remark }}</p>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, default: '' },
  value: { type: [Number, String], required: false },
  additionalClass: { type: String, default: '' },
  remark: { type: String, default: '' },
  id: { type: String, default: '' },
})
</script>

<style lang="postcss" scoped>
.core-summary-item {
  @apply border-t border-neutral-300;
  @apply flex flex-wrap justify-between py-4 text-neutral-650;
  .title {
    @apply text-neutral-450;
  }
  .value {
    @apply w-full md:w-auto md:text-right;
  }
  &.title-item {
    @apply mt-16 items-center border-t-0;
    .title {
      @apply text-lg text-neutral-650;
    }
  }
  &.highlight-item,
  &.dark-title {
    .title {
      @apply text-neutral-650;
    }
  }
  &.line-break {
    .value {
      @apply whitespace-pre-line;
    }
  }
  &.text-block {
    .value {
      @apply mt-4 w-full whitespace-pre-line text-left text-sm font-thin;
    }
  }
  &.muted-value {
    .value {
      @apply text-neutral-400;
    }
  }
  &.justification-text {
    @apply border-t-0 pt-0 pb-2;
    .title {
      @apply text-xs text-neutral-400 font-normal;
    }
  }
}
</style>
